<template>
	<div class="imgText">
		
	</div>
</template>
<script type="text/javascript">
	export default {
		data(){
			
		},
		mounted(){
			
		},
		methods:{
			
		}
	}
</script>
<style scoped>
	
</style>